import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import scrollIntoView from 'scroll-into-view-if-needed';

@Component({
  selector: 'app-help-basisfor-conclusions',
  templateUrl: './help-basisfor-conclusions.component.html'
})
export class HelpBasisforConclusionsComponent implements OnInit {

  constructor(public commonDataService: CommonDataService, private router: Router, private sanitizer: DomSanitizer,
    private graphQlService: GraphqlService) { }

  ngOnInit(): void {
   
    this.commonDataService.showLoader.next(true);
    this.getbasisforconclusionLabels();
  }
  basisforconclusion_header;
  basisforconclusion_para1header;
  basisforconclusion_para1body;
  basisforconclusion_para2header;
  basisforconclusion_para2body;
  basisforconclusion_para3header;
  basisforconclusion_para3body;
  basisforconclusion_para4header;
  basisforconclusion_para4body;
  basisforconclusion_para5header;
  basisforconclusion_para5body;
  basisforconclusion_para6header;
  basisforconclusion_para6body;
  basisforconclusion_para7header;
  basisforconclusion_para7body;
  basisforconclusion_para8header;
  basisforconclusion_para8body;


  getbasisforconclusionLabels() {

    this.graphQlService.gethelpbasisforconclusionLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.basisforconclusion_header = labels.filter(x => x.key == "basisforconclusion_header").map(y => y.value);
        this.basisforconclusion_para1header = labels.filter(x => x.key == "basisforconclusion_para1header").map(y => y.value);
        this.basisforconclusion_para1body = labels.filter(x => x.key == "basisforconclusion_para1body").map(y => y.value);
        this.basisforconclusion_para2header = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "basisforconclusion_para2header").map(y => y.value));
        this.basisforconclusion_para2body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "basisforconclusion_para2body").map(y => y.value));
        this.basisforconclusion_para3header = labels.filter(x => x.key == "basisforconclusion_para3header").map(y => y.value);
        this.basisforconclusion_para3body = labels.filter(x => x.key == "basisforconclusion_para3body").map(y => y.value);
        this.basisforconclusion_para4header = labels.filter(x => x.key == "basisforconclusion_para4header").map(y => y.value);
        this.basisforconclusion_para4body = labels.filter(x => x.key == "basisforconclusion_para4body").map(y => y.value);
        this.basisforconclusion_para5header = labels.filter(x => x.key == "basisforconclusion_para5header").map(y => y.value);
        this.basisforconclusion_para5body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "basisforconclusion_para5body").map(y => y.value));
        this.basisforconclusion_para6header = labels.filter(x => x.key == "basisforconclusion_para6header").map(y => y.value);
        this.basisforconclusion_para6body = labels.filter(x => x.key == "basisforconclusion_para6body").map(y => y.value);
        this.basisforconclusion_para7header = labels.filter(x => x.key == "basisforconclusion_para7header").map(y => y.value);
        this.basisforconclusion_para7body = labels.filter(x => x.key == "basisforconclusion_para7body").map(y => y.value);
        this.basisforconclusion_para8header = labels.filter(x => x.key == "basisforconclusion_para8header").map(y => y.value);
        this.basisforconclusion_para8body = labels.filter(x => x.key == "basisforconclusion_para8body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }

  openlink(event) {
    let id = event.target.id;
    let title = event.target.title;
    if (id != "") {
      if (this.router.url == '/Login') {
        this.commonDataService.NavigatingFromComponent.next("helpcrossreference");
        this.commonDataService.childComponent.next(true);
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next(event.target.name);
      } 
      else {
        this.router.navigate([event.target.id]);
      }
    }
    else if(title.includes("#")){
      const node = document.getElementById(title.replace("#",""));
      scrollIntoView(node, {
        scrollMode: 'always',
        block: 'start',
        inline: 'start',
        boundary: document.getElementsByTagName('app-main-content')[0]
      })
    }

  }
}
